<template>
  <div class="create-temp-user-template" theme>
    <div id="create-temp-user-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'user',
      parts: [
        {
          elem: '#create-temp-user-content',
          htmlFile: 'create_temp_user'
        }
      ]
    }
  }
}
</script>
